import React, { useState, useRef } from 'react';
import { useTranslation } from 'react-i18next';
import Button from 'apollo-react/components/Button';
import CommonModal from '../CommonModal';
import AssessmentStatusTable from './AssessmentStatusTable';
import AssessmentReviewerSection from './AssessmentReviewerSection';
import styles from './AssessmentReviewersTab.module.css';

const AssessmentReviewersTab = ({ initialData, currentUserEmail }) => {
  const { t } = useTranslation();
  const [tabData] = useState(initialData);
  const [viewStatusOpen, setViewStatusOpen] = useState(false);

  // initialise refs once from initial reviewers list
  const sectionRefs = useRef(
    Object.fromEntries(
      (initialData?.reviewers ?? []).map((r) => [
        r.assignmentId,
        React.createRef(),
      ])
    )
  );

  const ownSection = tabData?.reviewers?.find((r) => r.isOwnSection);
  const otherSections =
    tabData?.reviewers?.filter((r) => !r.isOwnSection) ?? [];

  const handleRowClick = (row) => {
    setViewStatusOpen(false);
    sectionRefs.current[row.assignmentId]?.current?.scrollIntoView({
      behavior: 'smooth',
    });
  };

  return (
    <div className={styles.container}>
      <div className={styles.ribbon}>
        <span className={styles.ribbonLabel}>
          {t('assessmentReviewsStatus')}
        </span>
        <Button
          size="small"
          onClick={() => setViewStatusOpen(true)}
          className={styles.ribbonButton}
        >
          {t('viewStatus')}
        </Button>
      </div>

      <CommonModal
        open={viewStatusOpen}
        onClose={() => setViewStatusOpen(false)}
        title={t('assessmentReviewsStatus')}
        hideButtons
        size="large"
      >
        <AssessmentStatusTable
          data={(tabData?.reviewers ?? []).map((r) => ({
            assignmentId: r.assignmentId,
            reviewerName: r.reviewerName,
            assessmentStatus: r.assessmentStatus,
          }))}
          onRowClick={handleRowClick}
        />
      </CommonModal>

      {ownSection && (
        <AssessmentReviewerSection
          key={ownSection.assignmentId}
          assignmentId={ownSection.assignmentId}
          reviewerName={ownSection.reviewerName}
          reviewerEmail={ownSection.reviewerEmail}
          assessmentStatus={ownSection.assessmentStatus}
          rejectionReason={ownSection.rejectionReason}
          isOwnSection
          callerRole={tabData.callerRole}
          sectionRef={sectionRefs.current[ownSection.assignmentId]}
          currentUserEmail={currentUserEmail}
        />
      )}

      {otherSections.map((r) => (
        <AssessmentReviewerSection
          key={r.assignmentId}
          assignmentId={r.assignmentId}
          reviewerName={r.reviewerName}
          reviewerEmail={r.reviewerEmail}
          assessmentStatus={r.assessmentStatus}
          rejectionReason={r.rejectionReason}
          isOwnSection={false}
          callerRole={tabData.callerRole}
          sectionRef={sectionRefs.current[r.assignmentId]}
          currentUserEmail={currentUserEmail}
        />
      ))}
    </div>
  );
};

export default AssessmentReviewersTab;
